module.exports = __webpack_public_path__ + "media/components/icons/SVG/dragots-b05993fd713831f9a2c40e52b7d20228.svg";